export const INTENSITIES = ['alacsony', 'közepes', 'magas'];
export const AIR_STRIKE_OPTIONS = [true, false];

export const normalize = (str) => {
	if (str == null) return '';
	return String(str)
		.toLowerCase()
		.normalize('NFD') // split letters + diacritics
		.replace(/[\u0300-\u036f]/g, '') // remove diacritics
		.replace(/[^a-z0-9]+/g, ' ') // keep letters & digits
		.trim()
		.replace(/\s+/g, ' '); // collapse spaces
};

export const areSetsEqual = (a, b) => {
	if (a.size !== b.size) return false;
	for (const v of a) if (!b.has(v)) return false;
	return true;
};

export const MARTIAL_KEYS_DELIMITERS = ['benne', ',', ';'];

export const MARTIAL_KEYS = {
	'lov.': 'lovas',
	'löv.': 'lövész',
	'dd.': 'dandár',
	'e.': 'ezred',
	'oszt.': 'osztály',
	'hk.': 'harckocsi',
	'hdt.': 'hadtest',
	'gr.': 'gránátos',
	'v.': 'vadász',
	'tü.': 'tüzér',
	'ro.': 'roham',
	'r.': 'román',
	'n.': 'német',
	'm.': 'magyar',
	'sz.': 'szovjet',
	'b.': 'bolgár',
	'j.': 'jugoszláv',
	'gy.': 'gyalog',
	'pc.': 'páncélos',
	'pcgr.': 'páncélgránátos',
	'hgy.': 'hegyi',
	'meger.körl.': 'megerődített körlet',
	'tart.': 'tartalék',
	'táb.': 'tábori',
	'zlj.': 'zászlóalj',
	'öj.tü.': 'önjáró tüzér',
	'ö.': 'önálló',
	'pct.': 'páncéltörő',
	'pcv.': 'páncélvadász',
	'feld.': 'felderítő',
	'u.': 'utász',
	'hír.': 'híradó',
	'tar.': 'tarackos',
	'á.': 'ágyús',
	'ne.': 'nehéz',
	'kö.': 'közepes',
	'k.': 'könnyű',
	'hds.': 'hadsereg',
	'hds.csop.': 'hadseregcsoport',
	F: 'front',
	U: 'ukrán',
	'rolg.': 'rohamlöveg',
	'g.': 'gépesített',
	'gd.': 'gárda',
	'szd.': 'század',
	'szak.': 'szakasz',
	'av.': 'aknavető',
	'sv.': 'sorozatvető',
	'bü.': 'büntető',
	'ho.': 'hadosztály',
	'pótho.': 'póthadosztály'
};

export const MARTIAL_COLOURS = {
	román: '#BFA688',
	német: '#63BBFF',
	magyar: '#81E7A1',
	szovjet: '#FF7A7C',
	bolgár: '#9E78FF'
};

export const MARTIAL_STRUCTURE = {
	nemzetiség: ['magyar', 'német', 'szovjet', 'román', 'bolgár']
};

export const MARTIAL_LEVELS = {
	szakasz: `<svg viewBox="0 0 43 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="6.5" cy="6.5" r="6.5" fill="white"/>
<circle cx="21.5" cy="6.5" r="6.5" fill="white"/>
<circle cx="36.5" cy="6.5" r="6.5" fill="white"/>
</svg>`,
	század: `<svg viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="2" height="20" fill="white"/>
</svg>`,
	zászlóalj: `<svg viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="15" width="2" height="20" fill="black"/>
<rect width="2" height="20" fill="black"/>
</svg>`,
	ezred: `<svg viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="15" width="2" height="20" fill="black"/>
<rect x="30" width="2" height="20" fill="black"/>
<rect width="2" height="20" fill="black"/>
</svg>`,
	dandár: `<svg viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5029L6.38965 9.8833L12.3535 0.263672" stroke="#404040"/>
<path d="M12.3535 19.5029L6.38965 9.8833L0.425781 0.263672" stroke="#404040"/>
</svg>`,
	hadosztály: `<svg viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5029L6.38965 9.8833L12.3535 0.263672" stroke="#404040"/>
<path d="M12.3535 19.5029L6.38965 9.8833L0.425781 0.263672" stroke="#404040"/>
<path d="M15.4258 19.5029L21.3896 9.8833L27.3535 0.263672" stroke="#404040"/>
<path d="M27.3535 19.5029L21.3896 9.8833L15.4258 0.263672" stroke="#404040"/>
</svg>`,
	póthadosztály: `<svg viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5029L6.38965 9.8833L12.3535 0.263672" stroke="#404040"/>
<path d="M12.3535 19.5029L6.38965 9.8833L0.425781 0.263672" stroke="#404040"/>
<path d="M15.4258 19.5029L21.3896 9.8833L27.3535 0.263672" stroke="#404040"/>
<path d="M27.3535 19.5029L21.3896 9.8833L15.4258 0.263672" stroke="#404040"/>
</svg>`,
	hadtest: `<svg viewBox="0 0 43 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5029L6.38965 9.8833L12.3535 0.263672" stroke="#404040"/>
<path d="M12.3535 19.5029L6.38965 9.8833L0.425781 0.263672" stroke="#404040"/>
<path d="M15.4258 19.5039L21.3896 9.88428L27.3535 0.264648" stroke="#404040"/>
<path d="M27.3535 19.5039L21.3896 9.88428L15.4258 0.264648" stroke="#404040"/>
<path d="M30.4258 19.5039L36.3896 9.88428L42.3535 0.264648" stroke="#404040"/>
<path d="M42.3535 19.5039L36.3896 9.88428L30.4258 0.264648" stroke="#404040"/>
</svg>`,
	hadsereg: `<svg viewBox="0 0 58 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5029L6.38965 9.8833L12.3535 0.263672" stroke="#404040"/>
<path d="M12.3535 19.5029L6.38965 9.8833L0.425781 0.263672" stroke="#404040"/>
<path d="M15.4258 19.5029L21.3896 9.8833L27.3535 0.263672" stroke="#404040"/>
<path d="M27.3535 19.5029L21.3896 9.8833L15.4258 0.263672" stroke="#404040"/>
<path d="M30.4258 19.5029L36.3896 9.8833L42.3535 0.263672" stroke="#404040"/>
<path d="M42.3535 19.5029L36.3896 9.8833L30.4258 0.263672" stroke="#404040"/>
<path d="M45.4258 19.5029L51.3896 9.8833L57.3535 0.263672" stroke="#404040"/>
<path d="M57.3535 19.5029L51.3896 9.8833L45.4258 0.263672" stroke="#404040"/>
</svg>`,
	hadseregcsoport: `<svg viewBox="0 0 73 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.425781 19.5098L6.38965 9.89014L12.3535 0.270507" stroke="#404040"/>
<path d="M12.3535 19.5098L6.38965 9.89014L0.425781 0.270507" stroke="#404040"/>
<path d="M15.4258 19.5107L21.3896 9.89111L27.3535 0.271484" stroke="#404040"/>
<path d="M27.3535 19.5107L21.3896 9.89111L15.4258 0.271484" stroke="#404040"/>
<path d="M30.4258 19.5107L36.3896 9.89111L42.3535 0.271484" stroke="#404040"/>
<path d="M42.3535 19.5107L36.3896 9.89111L30.4258 0.271484" stroke="#404040"/>
<path d="M45.4258 19.5107L51.3896 9.89111L57.3535 0.271484" stroke="#404040"/>
<path d="M57.3535 19.5107L51.3896 9.89111L45.4258 0.271484" stroke="#404040"/>
<path d="M60.4258 19.5029L66.3896 9.8833L72.3535 0.263672" stroke="#404040"/>
<path d="M72.3535 19.5029L66.3896 9.8833L60.4258 0.263672" stroke="#404040"/>
</svg>`
};

export const MARTIAL_ICONS = {
	lovas: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_942)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<path d="M15.8661 0.136719L0.132812 10.8617" stroke="white" stroke-width="0.5"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_942">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	harckocsi: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_948)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<path d="M5.62266 8.20208C4.17528 8.20208 3.00195 6.99209 3.00195 5.49948C3.00195 4.00687 4.17528 2.79688 5.62266 2.79688H10.3792C11.8266 2.79688 12.9999 4.00687 12.9999 5.49948C12.9999 6.99209 11.8266 8.20208 10.3792 8.20208H5.62266Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_948">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	gránátos: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_954)">
<path d="M15.8661 10.8617L0.132812 0.136719" stroke="white" stroke-width="0.5"/>
<path d="M15.8661 0.136719L0.132812 10.8617" stroke="white" stroke-width="0.5"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M8.26644 9.4668C8.16435 9.50846 8.03154 9.54909 7.868 9.58867C7.7055 9.62826 7.54508 9.64805 7.38675 9.64805C7.02112 9.64805 6.72946 9.54284 6.51175 9.33242C6.29508 9.12096 6.18675 8.82148 6.18675 8.43398C6.18675 8.0694 6.29508 7.77721 6.51175 7.55742C6.72946 7.33763 7.02685 7.22773 7.40394 7.22773C7.59873 7.22773 7.75706 7.24648 7.87894 7.28398C8.00081 7.32044 8.12685 7.37044 8.25706 7.43398V7.9793H8.20394C8.17581 7.95742 8.13519 7.92669 8.08206 7.88711C8.02998 7.84648 7.97894 7.81211 7.92894 7.78398C7.8706 7.75065 7.8029 7.72201 7.72581 7.69805C7.64977 7.67409 7.56904 7.66211 7.48363 7.66211C7.38363 7.66211 7.29248 7.67773 7.21019 7.70898C7.1279 7.74023 7.05446 7.78815 6.98987 7.85273C6.92842 7.91523 6.87946 7.9944 6.843 8.09023C6.80758 8.18607 6.78987 8.29753 6.78987 8.42461C6.78987 8.69648 6.8581 8.89701 6.99456 9.02617C7.13102 9.15534 7.31748 9.21992 7.55394 9.21992C7.57477 9.21992 7.59925 9.2194 7.62738 9.21836C7.6555 9.21732 7.67998 9.21576 7.70081 9.21367V8.75742H7.24925V8.32148H8.26644V9.4668ZM9.91794 8.36211H9.87262C9.85179 8.35482 9.82158 8.34961 9.782 8.34648C9.74242 8.34232 9.69867 8.34023 9.65075 8.34023C9.59346 8.34023 9.53304 8.34857 9.4695 8.36523C9.407 8.3819 9.34606 8.40169 9.28669 8.42461V9.59961H8.73981V7.84492H9.28669V8.09648C9.31169 8.07357 9.34606 8.04492 9.38981 8.01055C9.4346 7.97513 9.47523 7.94701 9.51169 7.92617C9.55127 7.90221 9.5971 7.8819 9.64919 7.86523C9.70231 7.84753 9.75231 7.83867 9.79919 7.83867C9.8169 7.83867 9.83669 7.83919 9.85856 7.84023C9.88044 7.84128 9.90023 7.84284 9.91794 7.84492V8.36211Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2453_954">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	tüzér: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_961)">
<path d="M0.132812 0.132812H15.8661V10.5328H0.132812V0.132812Z" stroke="white" stroke-width="0.133333"/>
<path d="M10.2553 5.33259C10.2554 5.62887 10.1971 5.92226 10.0838 6.19602C9.97052 6.46977 9.8044 6.71853 9.59494 6.92807C9.38548 7.1376 9.13679 7.30382 8.86307 7.41723C8.58936 7.53064 8.29599 7.58901 7.99971 7.58901C7.70343 7.58901 7.41006 7.53064 7.13634 7.41723C6.86263 7.30382 6.61394 7.1376 6.40448 6.92807C6.19502 6.71853 6.02889 6.46977 5.91559 6.19602C5.80229 5.92226 5.74403 5.62887 5.74414 5.33259C5.74403 5.03631 5.80229 4.74292 5.91559 4.46916C6.02889 4.1954 6.19502 3.94665 6.40448 3.73711C6.61394 3.52757 6.86263 3.36135 7.13634 3.24795C7.41006 3.13454 7.70343 3.07617 7.99971 3.07617C8.29599 3.07617 8.58936 3.13454 8.86307 3.24795C9.13679 3.36135 9.38548 3.52757 9.59494 3.73711C9.8044 3.94665 9.97052 4.1954 10.0838 4.46916C10.1971 4.74292 10.2554 5.03631 10.2553 5.33259Z" fill="white" stroke="white" stroke-width="0.266667" stroke-linecap="round"/>
<path d="M15.6162 0.382812V10.2832H0.382812V0.382812H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_961">
<rect width="16" height="10.6667" fill="white"/>
</clipPath>
</defs>
</svg>`,
	gyalog: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_979)">
<path d="M15.8661 10.8617L0.132812 0.136719" stroke="white" stroke-width="0.5"/>
<path d="M15.8661 0.136719L0.132812 10.8617" stroke="white" stroke-width="0.5"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2453_979">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	páncélos: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1006)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<path d="M5.62266 8.20208C4.17528 8.20208 3.00195 6.99209 3.00195 5.49948C3.00195 4.00687 4.17528 2.79688 5.62266 2.79688H10.3792C11.8266 2.79688 12.9999 4.00687 12.9999 5.49948C12.9999 6.99209 11.8266 8.20208 10.3792 8.20208H5.62266Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_1006">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	páncélgránátos: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1012)">
<path d="M2.5332 0.132812V10.8658" stroke="white" stroke-width="0.5"/>
<path d="M15.8661 0.136719L0.132812 10.8617" stroke="white" stroke-width="0.5"/>
<path d="M5.62305 3.04688H10.3789C11.6809 3.04688 12.7498 4.13739 12.75 5.49902C12.75 6.86087 11.681 7.95215 10.3789 7.95215H5.62305C4.32094 7.95215 3.25195 6.86087 3.25195 5.49902C3.25219 4.13739 4.32108 3.04688 5.62305 3.04688Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2453_1012">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	páncéltörő: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1026)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<mask id="path-2-inside-1_2453_1026" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.132812 10.8627L7.99948 0.302734L15.8661 10.8627"/>
</mask>
<path d="M7.99948 0.302734L8.40045 0.00403199L7.99948 -0.534219L7.59851 0.00403199L7.99948 0.302734ZM0.132812 10.8627L0.533782 11.1614L8.40045 0.601437L7.99948 0.302734L7.59851 0.00403199L-0.268157 10.564L0.132812 10.8627ZM7.99948 0.302734L7.59851 0.601437L15.4652 11.1614L15.8661 10.8627L16.2671 10.564L8.40045 0.00403199L7.99948 0.302734Z" fill="white" mask="url(#path-2-inside-1_2453_1026)"/>
<path d="M5.55273 6.1426L8.00055 4.21094L10.4484 6.1426" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M5.55273 5.00784L8.00055 3.07617L10.4484 5.00784" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_1026">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>
`,
	páncélvadász: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1040)">
<path d="M0.132812 10.8627L7.99948 0.302734L15.8661 10.8627" stroke="white" stroke-width="0.5"/>
<path d="M5.62266 8.20208C4.17528 8.20208 3.00195 6.99209 3.00195 5.49948C3.00195 4.00687 4.17528 2.79688 5.62266 2.79688H10.3792C11.8266 2.79688 12.9999 4.00687 12.9999 5.49948C12.9999 6.99209 11.8266 8.20208 10.3792 8.20208H5.62266Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2453_1040">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	tarackos: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1052)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<path d="M10.2553 5.50076C10.2554 5.80629 10.1971 6.10886 10.0838 6.39117C9.97052 6.67348 9.8044 6.93001 9.59494 7.14609C9.38548 7.36218 9.13679 7.53359 8.86307 7.65054C8.58936 7.76749 8.29599 7.82769 7.99971 7.82769C7.70343 7.82769 7.41006 7.76749 7.13634 7.65054C6.86263 7.53359 6.61394 7.36218 6.40448 7.14609C6.19502 6.93001 6.02889 6.67348 5.91559 6.39117C5.80229 6.10886 5.74403 5.80629 5.74414 5.50076C5.74403 5.19522 5.80229 4.89266 5.91559 4.61035C6.02889 4.32804 6.19502 4.07151 6.40448 3.85542C6.61394 3.63934 6.86263 3.46792 7.13634 3.35097C7.41006 3.23402 7.70343 3.17383 7.99971 3.17383C8.29599 3.17383 8.58936 3.23402 8.86307 3.35097C9.13679 3.46792 9.38548 3.63934 9.59494 3.85542C9.8044 4.07151 9.97052 4.32804 10.0838 4.61035C10.1971 4.89266 10.2554 5.19522 10.2553 5.50076Z" fill="white" stroke="white" stroke-width="0.266667" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_1052">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	ágyús: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1058)">
<path d="M0.132812 10.8627L7.99948 0.302734L15.8661 10.8627" stroke="white" stroke-width="0.5"/>
<path d="M10.2553 5.50024C10.2553 5.80573 10.197 6.10824 10.0837 6.39049C9.97035 6.67274 9.80421 6.92921 9.59476 7.14524C9.3853 7.36127 9.13664 7.53264 8.86296 7.64956C8.58928 7.76647 8.29594 7.82665 7.99971 7.82665C7.70347 7.82665 7.41014 7.76647 7.13646 7.64956C6.86278 7.53264 6.61411 7.36127 6.40466 7.14524C6.1952 6.92921 6.02907 6.67274 5.91574 6.39049C5.8024 6.10824 5.7441 5.80573 5.74414 5.50024C5.7441 5.19475 5.8024 4.89224 5.91574 4.60999C6.02907 4.32774 6.1952 4.07127 6.40466 3.85524C6.61411 3.63921 6.86278 3.46784 7.13646 3.35092C7.41014 3.234 7.70347 3.17383 7.99971 3.17383C8.29594 3.17383 8.58928 3.234 8.86296 3.35092C9.13664 3.46784 9.3853 3.63921 9.59476 3.85524C9.80421 4.07127 9.97035 4.32774 10.0837 4.60999C10.197 4.89224 10.2553 5.19475 10.2553 5.50024Z" fill="white"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2453_1058">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	aknavető: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1064)">
<path d="M0.132812 0.136719H15.8661V10.8617H0.132812V0.136719Z" stroke="white" stroke-width="0.133333"/>
<path d="M8.89329 8.20126C8.89329 8.71261 8.49132 9.12714 7.99547 9.12714C7.49962 9.12714 7.09766 8.71261 7.09766 8.20126C7.09766 7.68992 7.49962 7.27539 7.99547 7.27539C8.49132 7.27539 8.89329 7.68992 8.89329 8.20126Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M7.99609 7.27527V1.92578" stroke="white" stroke-width="0.5"/>
<path d="M8.97055 2.87104L7.99992 1.92578L7.0293 2.87104" stroke="white" stroke-width="0.5"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5"/>
</g>
<defs>
<clipPath id="clip0_2453_1064">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	sorozatvető: `<svg viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2453_1073)">
<path d="M9.51175 5.71954C9.5118 5.92431 9.47273 6.12707 9.39679 6.31626C9.32084 6.50546 9.20949 6.67737 9.06911 6.82217C8.92873 6.96698 8.76206 7.08185 8.57862 7.16022C8.39518 7.23859 8.19857 7.27893 8.00001 7.27893C7.80146 7.27893 7.60484 7.23859 7.42141 7.16022C7.23797 7.08185 7.0713 6.96698 6.93092 6.82217C6.79053 6.67737 6.67919 6.50546 6.60324 6.31626C6.52729 6.12707 6.48823 5.92431 6.48828 5.71954C6.48823 5.51478 6.52729 5.31201 6.60324 5.12282C6.67919 4.93363 6.79053 4.76172 6.93092 4.61692C7.0713 4.47211 7.23797 4.35724 7.42141 4.27887C7.60484 4.20049 7.80146 4.16016 8.00001 4.16016C8.19857 4.16016 8.39518 4.20049 8.57862 4.27887C8.76206 4.35724 8.92873 4.47211 9.06911 4.61692C9.20949 4.76172 9.32084 4.93363 9.39679 5.12282C9.47273 5.31201 9.5118 5.51478 9.51175 5.71954Z" fill="white" stroke="white" stroke-width="0.2" stroke-linecap="round"/>
<path d="M5.55273 4.13674L8.00055 2.20508L10.4484 4.13674" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M5.55273 3.00198L8.00055 1.07031L10.4484 3.00198" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M8.83645 8.9056C8.83649 9.01887 8.81489 9.13104 8.77288 9.23569C8.73088 9.34035 8.66929 9.43545 8.59164 9.51556C8.51399 9.59566 8.42179 9.65921 8.32032 9.70256C8.21885 9.74592 8.11009 9.76823 8.00026 9.76823C7.89042 9.76823 7.78166 9.74592 7.68019 9.70256C7.57872 9.65921 7.48652 9.59566 7.40887 9.51556C7.33122 9.43545 7.26963 9.34035 7.22763 9.23569C7.18562 9.13104 7.16402 9.01887 7.16406 8.9056C7.16402 8.79233 7.18562 8.68017 7.22763 8.57551C7.26963 8.47085 7.33122 8.37575 7.40887 8.29565C7.48652 8.21554 7.57872 8.15199 7.68019 8.10864C7.78166 8.06528 7.89042 8.04297 8.00026 8.04297C8.11009 8.04297 8.21885 8.06528 8.32032 8.10864C8.42179 8.15199 8.51399 8.21554 8.59164 8.29565C8.66929 8.37575 8.73088 8.47085 8.77288 8.57551C8.81489 8.68017 8.83649 8.79233 8.83645 8.9056Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M11.6919 8.9056C11.692 9.01887 11.6704 9.13104 11.6284 9.23569C11.5863 9.34035 11.5248 9.43545 11.4471 9.51556C11.3695 9.59566 11.2773 9.65921 11.1758 9.70256C11.0743 9.74592 10.9656 9.76823 10.8557 9.76823C10.7459 9.76823 10.6371 9.74592 10.5357 9.70256C10.4342 9.65921 10.342 9.59566 10.2643 9.51556C10.1867 9.43545 10.1251 9.34035 10.0831 9.23569C10.0411 9.13104 10.0195 9.01887 10.0195 8.9056C10.0195 8.79233 10.0411 8.68017 10.0831 8.57551C10.1251 8.47085 10.1867 8.37575 10.2643 8.29565C10.342 8.21554 10.4342 8.15199 10.5357 8.10864C10.6371 8.06528 10.7459 8.04297 10.8557 8.04297C10.9656 8.04297 11.0743 8.06528 11.1758 8.10864C11.2773 8.15199 11.3695 8.21554 11.4471 8.29565C11.5248 8.37575 11.5863 8.47085 11.6284 8.57551C11.6704 8.68017 11.692 8.79233 11.6919 8.9056Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M5.98098 8.90587C5.98105 9.01916 5.95948 9.13136 5.91749 9.23604C5.8755 9.34073 5.81392 9.43586 5.73626 9.516C5.65861 9.59613 5.5664 9.6597 5.46491 9.70307C5.36343 9.74645 5.25464 9.76877 5.14479 9.76877C5.03493 9.76877 4.92615 9.74645 4.82466 9.70307C4.72317 9.6597 4.63097 9.59613 4.55331 9.516C4.47566 9.43586 4.41407 9.34073 4.37208 9.23604C4.33009 9.13136 4.30852 9.01916 4.30859 8.90587C4.30852 8.79258 4.33009 8.68038 4.37208 8.5757C4.41407 8.47101 4.47566 8.37588 4.55331 8.29574C4.63097 8.21561 4.72317 8.15204 4.82466 8.10866C4.92615 8.06529 5.03493 8.04297 5.14479 8.04297C5.25464 8.04297 5.36343 8.06529 5.46491 8.10866C5.5664 8.15204 5.65861 8.21561 5.73626 8.29574C5.81392 8.37588 5.8755 8.47101 5.91749 8.5757C5.95948 8.68038 5.98105 8.79258 5.98098 8.90587Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
<path d="M15.6162 0.386719V10.6113H0.382812V0.386719H15.6162Z" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2453_1073">
<rect width="16" height="11" fill="white"/>
</clipPath>
</defs>
</svg>`,
	utász: `<svg viewBox="-1 -1 62 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H59V39H0V0Z" fill="none" stroke="white" stroke-width="2"/>
<path d="M29.5 27.5996V12.5996M14.5 27.5996V12.5996H44.5V27.5996" stroke="white" stroke-width="2.4"/>
</svg>`,
	'önjáró tüzér': `<svg viewBox="0 0 114 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="111" height="73" stroke="white" stroke-width="3"/>
<rect x="12.5" y="16.5" width="88" height="42" rx="21" stroke="white" stroke-width="3"/>
<circle cx="57" cy="38" r="12" fill="white"/>
</svg>`,
	lövész: `<svg viewBox="0 0 61 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.599609 0.599609L59.5996 39.5996M59.5996 0.599609L0.599609 39.5996" stroke="white"/>
<path d="M0.599609 0.599609H59.5996V39.5996H0.599609V0.599609Z" stroke="white" stroke-width="1.2"/>
</svg>`
};

export const MARTIAL_ICON_FALLBACK = `<svg viewBox="-1 -1 62 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H59V39H0V0Z" fill="none" stroke="white" stroke-width="2"/>
</svg>`;

export const DB_TIMELINE_START = -820540800000;
export const DB_TIMELINE_END = -757987200000;

export function clamp(input, min, max) {
	return input < min ? min : input > max ? max : input;
}

export function map(current, in_min, in_max, out_min, out_max) {
	const mapped = ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
	return clamp(mapped, out_min, out_max);
}
